import {
  mdiVectorCircle,
  mdiFormSelect,
  mdiFolderAccount,
} from '@mdi/js'

export default [
  {
    subheader: 'FORM BUILDER',
  },
  {
    title: 'Template',
    icon: mdiVectorCircle,
    to: 'form-template-list',
  },
  {
    title: 'Forms',
    icon: mdiFormSelect,
    to: 'published-template-list',
  },
  // {
  //   title: 'Shared with me',
  //   icon: mdiFolderAccount,
  //   to: 'shared-form-list',
  // },
  // {
  //   title: 'Trash',
  //   icon: mdiDeleteRestore,
  //   to: 'trash-form-list',
  // },
  // {
  //   title: 'Bookmark',
  //   icon: mdiBookmark,
  //   to: 'bookmark-form-list',
  // },

]
